<template>
    <div style="background:white" class="ve-list-page">
        <div style=" background:white;line-height:30px;border-bottom:2px solid #389"> 
            <div style="padding-top:3px;display:flex;width:1400px; ">
                <div style="width:90px">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" style="margin-top:0px;"><span style="font-size:13px;font-weight:600">{{ $LANG('0138', '新增') }} </span></el-link>
                </div>
 
                <span style=" font-size:12px;margin-right:10px;">{{ $LANG('0681', '字段查询') }}</span>
                <el-select v-model="selparam" size="small" placeholder="" clearable  style="width:150px; " >
                    <span v-for="item in poCol" :key='item.key'>
                        <el-option :label="$translate.getColTitle(item, $store.state.lang)" :value="item.key" v-if="item.thide=='N' "></el-option>
                    </span>
                </el-select>
                <el-input placeholder="" v-model="txtparam" @keyup.enter.native="stfgChange" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="stfgChange" ></el-button>
                </el-input> 
                <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
                <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
            </div>
        </div>
        <div class="ve-list-page__table">
        <ve-table :columns="vueCol"
            :table-data="poData"
            :columnHiddenOption="columnHiddenOption"
            :border-around="true"
            :border-x="true"
            :border-y="true"
            :fixed-header="true"
            row-key-field-name="IDSEQ"
            :row-style-option="rowStyleOption"
            :cell-style-option="cellStyleOption"
            :max-height="subHeight"
            :virtual-scroll-option="virtualScrollOption"
            :scroll-width="0"
            :column-width-resize-option="columnWidthResizeOption"
            :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
            :cellSelectionOption="{enable: false}"
            v-loading="v_loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 251, 255, 0.8)"
            id="stk_check_load"
            ref="refreq">
        </ve-table>
        </div>
        <!-- 分页查询 -->
        <div style="margin-top: 5px; overflow: hidden;display:flex;background:white;font-size:12px" class="ve-list-page__pagination">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">每页</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">跳至</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">页</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
        <!-- 提示框 -->
        <el-dialog :show-close="false" v-dialogDrag :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <div slot="footer">
                <Button type="primary"   @click="promptWin=false" style="margin-right:20px;">确定</Button>
            </div>
        </el-dialog>
        <!-- 新增、编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <Form :model="poRow" :label-width="110" ref="dtlform"  label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in poCol" :key="index" >
                        <FormItem   :label="item.title"  class="item-width" v-if="item.fhide==='N'" :prop="item.key"  >                  
                            <el-date-picker size="medium" :disabled="saveFlag" type="date"  v-if="item.edcss==='date'" v-model="poRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                            <el-input-number size="medium" :disabled="saveFlag" :precision="item.dotnum"  v-else-if="item.edcss==='number'" v-model="poRow[item.key]" style="width:100%" ></el-input-number>   
 
                            <el-select size="medium" v-else-if="item.edcss==='select'" v-model="poRow[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                            </el-select>
                            <el-input size="medium" :disabled="saveFlag ||item.disabled==='Y'?true:false" type="text" v-else   v-model="poRow[item.key]" ></el-input>
                        </FormItem>
                    </span>
                </Form>
                <div class="one-toolbar"><span class="spanRow">盘点明细 </span>
                    【
                        <i class="iconfont icon-xiazai" style="color:white;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                        <el-link :disabled="addBool||saveFlag" @click="refStk" :underline="false" style="color:white"><span style="font-size:13px;margin-right:15px;">引用库存明细</span></el-link>  
 
                    】
                </div>
                <el-table  :data="dtlData" 
                    border                            
                    size="small"
                    class="custom-table-border"
                    :height="dtlHeight" 
                    :row-key="getDtlKey"
                    cell-class-name="clearPadding"
                    ref="refdtl"
                    style="margin-top:-8px"
                    v-loading="t_loading"
                    element-loading-text="加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 251, 255, 0.8)"
                    :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
                    highlight-current-row > 
                    <el-table-column type="index" label="序号" width="55" ></el-table-column>
                    <el-table-column v-for="(item,index ) in dtlCol.filter(item=>item.thide=='N')" :key="index" 
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.key!=='RN'&&item.sortable=='N'"
                        :min-width="item.width">
                        <template slot="header">
                            <span v-if="item.notnull=='Y'" style="color:red">{{item.title}}</span>
                            <span v-else >{{item.title}}</span>
                        </template>                 
                        <template slot-scope="scope">                
                            <span v-if ="saveFlag" >
                                <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                <span v-else v-text="scope.row[item.key]"></span>
                            </span>
                            <span v-else >
                                <el-input type="number" @input="handleEdit(scope.row,scope.$index  )" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"    size="mini" v-if="item.edcss=='number'" :controls="false"  v-model="scope.row[item.key]" style="width:100%"> </el-input>                                             
                                
                                <el-input  v-else-if="item.disabled=='N'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input>     
                                <span v-else v-text="scope.row[item.key]"></span>
                            </span>
                        </template> 
                    </el-table-column>  
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="130">
                        <template slot-scope="scope">
                            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link @click="dtlDel(scope.row, scope.$index)" :disabled="saveFlag" :underline="false"  ><span style="font-size:12px;margin-right:5px; ">删除</span></el-link>
                            <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link @click="qryStkLog(scope.row )"  :underline="false"  ><span style="font-size:12px;margin-right:5px; ">库存日志</span></el-link>
 
                        </template>
                    </el-table-column>  
                </el-table>
                <div style="margin-top: 5px; overflow: hidden;display:flex;background:white;font-size:12px">
                    <div style="float: left;padding-left:4px;font-size:12px;">
                        <Page :total="dtlCount" :page-size="rowSize" show-total :current="dtlpage" @on-change="changePage"></Page>
                    </div>
                </div>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                <span style="float:right">            
                    <i class="web-font" style="font-size:14px;margin-right:20px;color:#ed4014;font-weight:600"> 提示：订单审核后不能再编辑 , 如需编辑请弃审</i> 
                    <span style="margin-right:20px">
                        <i v-if="poRow['STFG']==='N'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-weishenhe3"> </i>
                        <i v-else-if="poRow['STFG']==='Y'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yishenhe1"> </i>
                        <i v-else-if="poRow['STFG']==='X'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yizuofei"> </i>
                    </span>
                    <el-button type="info" @click="addWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                    <el-button :disabled="addBool||saveFlag"  @click="saveRec" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > 保存 </el-button> 
                </span>
            </div>
        </el-dialog>
 
        <!-- 查看库存 -->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="logWin" :width="tabWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">库存日志</span>
            </div> 
            <div style="height:91vh;overflow-y:auto"><stklog v-bind:toolFlag="toolFlag"  v-bind:v_cond="qryCond"></stklog></div>
        </el-dialog>
 
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0059', '报表参数') }}</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog>
        <!-- 选择仓库日志 -->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="ordWin" :width="tabWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择仓库日志</span>
            </div> 
            <div style="height:91vh;overflow-y:auto"><logInfo v-bind:v_stkno="v_stkno" @child-sure="ordSel"></logInfo></div>
        </el-dialog>
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate} from '../../api/Select' 
import logInfo from '../datamgt/log_tmpl.vue'
import stklog from './prd_stklog.vue'
import repWin from '../datamgt/repWin.vue'  
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
import { buildVeTableFieldCondition, buildVeTableHeaderCondition, isVeTableMetadataField } from '@/utils/veTableHeaderQuery'
export default {
    name:'stk_check',
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '96',
            fieldIdseq: '96',
            fieldLstseq: '1',
            mainColumnKey: 'poCol',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'refreq',
            columnHiddenOptionKey: 'columnHiddenOption',
            generatedFixedColumnKeys: ['rownum', 'oper'],
        })
    ],
    data () {
        return {
            sendVal:'PRD',
            toolFlag:false,
            logWin:false,
            qryCond:'',
            dtlRow:{},
            ordWin:false,
 
 
            comboArr:[],
            promptWin:false,
            dtlFlag:'create',
            prdRow:{},
            supFlag:'',
            addFlag:'create',
            supRow:{
                SUPNO:'' ,//供应商编码
                SUPNM:'', //供应商名称
                RMK:'', //备注
            },
            rowDtl:{},
            v_stkno:'',
            delPrdArr:[],
            stfgSet:'ALL',
            delDtlArr:[],
            prompt:'',
            input_hold:'请输入内容...',
            ruleValidate:{},
            dtlValidate:{'MATNO':[{ required: true, message: '请输入产品编码', trigger: 'blur' }],
                        'ACTQTY':[{ required: true, message: '收货数量', trigger: 'blur' }]},
            selparam:'IDNO',
            txtparam:'',
            poRow:{},
            prdFlag:'create',
            goPage:'',
            dtlpage:1,
            poData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            cancelBool:false, //作废权限
            v_loading:false,
            current:1,
            saveFlag:false,
            allList:[], //询价单集合
            dtlData:[],
            matData:[],
            addWin:false,
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            v_url:'xuper_auth/getTableRecMany', //api请求路径   
            options: [{
                value: 100,
                label: '100'
                }, {
                value: 200,
                label: '200'
                }],
            dataCount:0,
            dtlCount:0,
            rowSize:100,
            dtlCol:[],
            matCol:[],
            poCol:[],
            initCol:[],
            vueCol:[],
            columnHiddenOption: {
                defaultHiddenColumnKeys: [],
            },
            rowStyleOption: {
                clickHighlight: true,
            },
            cellStyleOption: {
                headerCellClass: () => 'table-head-cell-class',
                bodyCellClass: () => 'table-body-cell-class1',
            },
            repDlg:false,
            virtualScrollOption: { enable: false },
            queryRequestId: 0,
            headerSortKey: '',
            headerSortOrder: '',
            operArr:[],
            prcCol:[],
            prcData:[],
            prdIndex:'',
            oper:'like',
            stfgBool:true,
            v_idseq:this.$cookies.get('idseq'),
            dtlIndex:'',
            allData:[],
            t_loading:false,  
            showVisible:false,
            v_row:{},
            v_replist:[],
            v_idno:'',
            repArr:[],
            repUrl:'',
            repWin:false,
        }
    },
    components: {
 
      repWin,  
      logInfo, //stock   
 
      stklog,
      VeColumnConfigDialog,
    },
    computed: {
        subHeight: function() {
            return (window.innerHeight - 162) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 330) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth- 140) + 'px';
        },
    },
    mounted () {
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });  
        this.comSelect()
         //用户权限表
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','96','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })    
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','96','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
         //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','96','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空',trigger: 'blur'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        });
    },
    created () {
        if (this.v_username){
            this.getTabCol() //表列集合
            this.getPoList('')  
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt =this.$LANG('1678', '请选择报表')
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
            }
        },
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.stfgChange()
        } ,
        handleEdit(row,index){
 
            if (row['NOQTY'] ){
                row['ACTQTY']= Number(row['NOQTY'])-Number( row['STKQTY'])       
            }
        },
 
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'96',p_cond:' and lstseq in (1,2)',p_key2:'edcss',p_value2:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //查看库存
        qryStkLog(row){
            this.logWin=true
            this.qryCond=' and matno=\''+row.MATNO+'\''
        },
        //仓库明细选择
        ordSel(data_){
            if (data_.length>0){ //IDNO,MATNM,MATDESC,MODELNM,MATTYNM,PRC,TTLAMT,QTY ::TAXPRC,AMT
                for(let k=0;k<data_.length;k++){
                    let obj_={}
                    Object.assign(obj_,{MATNO:data_[k].MATNO,MATNM:data_[k].MATNM,MATDESC:data_[k].MATDESC,IDSEQ:'',LSTSEQ:'',ACTQTY:0,
                                        MATTYNM:data_[k].MATTYNM, STKQTY:data_[k].QTY, NOQTY:data_[k].QTY,STKNO:data_[k].STKNO,STKNM:data_[k].STKNM})
                    this.dtlData.push(obj_)
                }   
            }
            this.ordWin=false
        },
 
        refStk(){
            if (this.poRow['STKNO']){
                this.ordWin =true
                this.v_stkno=this.poRow['STKNO']
                
            }else{
                this.promptWin=true
                this.prompt='请选择盘点仓库'
            }
        },
 
 
        //盘点明细 
        getDtlList(idseq ){
            this.dtlData=[]
            this.t_loading=true
            getTabColOrData(this.v_url,'v_IC_STKdtl','idseq',idseq,'','','','','' ).then((res) => { 
                this.allData =res.result 
                this.initDtl()
                this.t_loading =false
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.refdtl.doLayout()
                })
            })
             
        },
 
        //明细编辑、删除
        dtlDel(row,index){
            this.delDtlArr.push(row)
            this.dtlData.splice(index,1 )
        },
 
        //编辑记录
        editRec(row,val,index){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                if (row.STFG==='Y'){
                    this.saveFlag=true
                }else{
                    this.saveFlag=false
                }   
            }
            this.addFlag='edit'
            this.poRow =JSON.parse(JSON.stringify(Object.assign(row,{IDSEQ:row.IDSEQ})))
            //盘点明细
            this.getDtlList(row.IDSEQ)
            this.addWin=true      
        },
        //保存记录
        saveRec(){
            //发起保存请求   
            //发起保存请求   
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.poRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.FLDNM+'不能为空'
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            if (this.stfgBool  ) {
                let  v_qty=false
                this.dtlData.forEach(item=>{
                    if (!item['NOQTY']){
                        v_qty =true
                    }
                })
                if (this.dtlData.length==0){
                    this.promptWin =true
                    this.prompt ='明细资料不能为空'
                }else if ( v_qty){
                    this.promptWin =true
                    this.prompt ='明细资料中的盘点数量不能为空'
                } else{
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(Object.assign(this.poRow,{CORPID:this.v_corpid})), p_table:'IC_STK',frmid:'96'},
                    }).then(res=>{      
                        if(res.code ==='200')  {  
                            let idseq_ =res.idseq
                            //1、盘点明细保存：批量保存   
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.dtlData), p_table:'IC_STKDTL',p_idseq:idseq_ , p_action:'S' },
                            }).then(res=>{
                                if (res.code!=='200'){
                                    this.promtWin=true
                                    this.prompt=res.result
                                }
                            })
                            //盘点明细删除
                            for (let k=0;k<this.delDtlArr.length;k++) {
                                this.$axios({   
                                    method: 'post',
                                    url:'xuper_auth/delTabRec',
                                    data: {p_key:'idseq',p_value: idseq_,p_key2:'lstseq',p_value2:this.delDtlArr[k].LSTSEQ, p_table:'IC_STKdtl'  },
                                })
                            } 
        
                            this.addWin =false   
                            this.getPoList('')
                        }else{
                            this.promptWin=true
                            this.prompt=res.result
                        }        
                    })  
                }
            }
        },
        //新增
        addRec(){
            this.addWin=true
            this.poRow={ICDTTM:getDate('day'),'IDSEQ':'',IDTY:'CHECK'}
            this.dtlData=[]
            this.saveFlag=false
        },
        //表行记录css
        tableRowClass({row, rowIndex}) {
            if (row.STFG  === 'Y') {
                return 'success-row';
            } else if (row.STFG ==='X') {
                return 'cancel-row';
            }
            return '';
        },
        getRowKey(row){
            return row.IDSEQ
        },
        getDtlKey(row){
            if (row.IDSEQ && row.LSTSEQ)
            return row.IDSEQ+'-'+row.LSTSEQ
        },
 
        //状态变更
        stfgRec(row,val,index){
            let v_comm='' ,v_cond='', v_chkuser='',v_chkdttm=''
            if (val==='K'){
                v_comm='确认'
            }else if (val==='N'){
                v_comm='弃认'
            }else if (val==='X'){
                v_comm='作废'
            }
            if (val=='K'){
                v_chkuser =this.v_usernm
                v_chkdttm=getDate('full')
                v_cond =' set stfg=\''+val+'\' ,appuser=\''+v_chkuser+'\',appdttm=\''+v_chkdttm+'\''
            }else{
                v_cond =' set stfg=\''+val+'\' ,appuser=null,appdttm=null'
            }
            this.$confirm('你确定要'+v_comm+'此单据吗?','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'IC_STK',p_cond: v_cond},
                }).then(res=>{      
                    if(res.code =='200')  {  
                        if (val=='X'){
                            this.poData.splice(index,1)
                        }else{          
                            Object.assign(row,{STFGNM:v_comm ,STFG:val,APPUSER:v_chkuser,APPDTTM:v_chkdttm})
                        }
                    }else{
                        const errorMsg =res.result
                        const startIndex = errorMsg.indexOf("ORA-20001:") 
                        const endIndex = errorMsg.indexOf("请核查") +3
                        const extractedValue = errorMsg.substring(startIndex, endIndex).trim()
                        if (startIndex>0){
                            this.prompt =extractedValue
                        }else{
                            this.prompt =res.result
                        }
                        this.promptWin =true
                    }        
                })
            }).catch(()=>{})
             
        },
 
 
        //状态查询
        stfgChange(){
            this.headerSortKey = ''
            this.headerSortOrder = ''
            const toolbarCondition = buildVeTableFieldCondition(this.initCol, this.selparam, this.txtparam, this.oper)
            const headerCondition = buildVeTableHeaderCondition(this.initCol, this.v_row, {
                typeOverrides: { STFG: 'select' },
                numberOperatorDefault: '>=',
            })
            this.current = 1
            const p_cond = toolbarCondition + headerCondition
            this.getPoList(p_cond)
        },
        sortHeaderColumn(column, edcss){
            const key = column && (column.field || column.key)
            if (!isVeTableMetadataField(this.initCol, key)) return
            if (this.headerSortKey === key) {
                this.headerSortOrder = this.headerSortOrder === 'asc' ? 'desc' : 'asc'
            } else {
                this.headerSortKey = key
                this.headerSortOrder = 'asc'
            }
            const direction = this.headerSortOrder === 'asc' ? 1 : -1
            const type = String(edcss || '').toLowerCase()
            this.poData.sort((left, right) => {
                const leftValue = left[key]
                const rightValue = right[key]
                if (leftValue === rightValue) return 0
                if (leftValue === null || leftValue === undefined || leftValue === '') return 1
                if (rightValue === null || rightValue === undefined || rightValue === '') return -1
                if (type === 'number') return (Number(leftValue) - Number(rightValue)) * direction
                if (type === 'date' || type === 'date2' || type === 'time') {
                    return (new Date(leftValue).getTime() - new Date(rightValue).getTime()) * direction
                }
                return String(leftValue).localeCompare(String(rightValue), undefined, { numeric: true }) * direction
            })
        },
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.$alert('请输入跳至页数', '提示', {
                    confirmButtonText: '确定',
                    showClose:false,
                    type:'info'
                })
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.poData = this.allList.slice(_start,_end);
        },
        changeDtl(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.dtlpage =index
            this.dtlData = this.allData.slice(_start,_end);
        },
        initDtl(){
            //产品明细
            this.dtlCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.dtlData = this.allData          
            }else{
                this.dtlData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
            }
            this.$nextTick(() => { //有固定列时 查询后重新布局
                this.$refs.refdtl.doLayout();
            }) 
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.rowSize){
                this.poData = this.allList          
            }else{
             
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.poData =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
            this.$nextTick(() => { //有固定列时 查询后重新布局
                const table = this.$refs.refreq
                if (table && typeof table.doLayout === 'function') table.doLayout()
            }) 
        },
 
        //报价单 
        getPoList(p_cond){
            const requestId = ++this.queryRequestId
            const orderField = isVeTableMetadataField(this.initCol, this.selparam) ? this.selparam : 'IDNO'
            this.v_loading = true
            getTabColOrData(this.v_url,'v_IC_STK','IDTY','CHECK','CORPID',this.v_corpid,'','',p_cond + ' order by ' + orderField + ' desc').then((res) => {
                if (requestId !== this.queryRequestId) return
                this.allList = res.result || []
                this.initPage()
            }).catch(error => {
                if (requestId !== this.queryRequestId) return
                this.prompt = error.message || this.$LANG('1641', '查询失败')
                this.promptWin = true
            }).finally(() => {
                if (requestId === this.queryRequestId) this.v_loading = false
            })
        },
 
        //报价商品 
        getMatList(idseq){
            getTabColOrData(this.v_url,'v_IC_STKdtl','idseq',idseq,'','','','','' ).then((res) => { 
                this.matData =res.result 
                if (res.length>0){
                    this.$refs['refmat'].setCurrentRow(res.result[0])
                }else{
                    this.prcData=[]
                }
            })
        },
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','96','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                vm.initCol = res.result
                return vm.loadInitialFieldSettings().then(() => {
                    const fieldRows = vm.sortFieldRows(vm.initCol)
                    vm.poCol = []
                    vm.vueCol = []
                    fieldRows.forEach(rowField => {
                        const itcol = rowField
                        const title = vm.$translate.getColTitle(itcol, vm.$store.state.lang)
                        vm.poCol.push({
                            title,
                            key: itcol.key,
                            align: itcol.align,
                            width: itcol.width,
                            thide: itcol.THIDE,
                            fhide: itcol.FHIDE,
                            edcss: itcol.EDCSS,
                            disabled: itcol.DISABLED,
                            dotnum: itcol.DOTNUM,
                            sortable: itcol.SORTABLE,
                        })
                        if (itcol['THIDE']=='N'){
                            vm.vueCol.push({
                                field: itcol.key,
                                key: itcol.key,
                                title,
                                align: itcol.align,
                                width: Number(itcol.width) || 120,
                                thide: itcol.THIDE,
                                fhide: itcol.FHIDE,
                                disabled: itcol.DISABLED,
                                sortable: itcol.key !== 'RN' && itcol.SORTABLE === 'N' && itcol.EDCSS !== 'checkbox',
                                renderHeaderCell: ({column}) => {
                                    const type = String(itcol.EDCSS || '').toLowerCase()
                                    if (itcol.key === 'STFG') {
                                        return (
                                            <div>
                                                <div style="margin-top:3px;white-space:nowrap"><el-link underline={false} on-click={() => this.sortHeaderColumn(column, itcol.EDCSS)}>{column.title}</el-link></div>
                                                <el-select value={this.v_row[itcol.key]} size="mini" on-change={(value) => { this.$set(this.v_row, itcol.key, value); this.stfgChange() }} placeholder="" filterable clearable style="width:100%">
                                                    <el-option label={this.$LANG('1976', '已审核')} value="Y"></el-option>
                                                    <el-option label={this.$LANG('2005', '未审核')} value="N"></el-option>
                                                </el-select>
                                            </div>
                                        )
                                    }
                                    if (type === 'date2' || type === 'date') {
                                        return (
                                            <div>
                                                <div style="margin-top:3px;white-space:nowrap"><el-link underline={false} on-click={() => this.sortHeaderColumn(column, itcol.EDCSS)}>{column.title}</el-link></div>
                                                <el-date-picker value={this.v_row[itcol.key]} on-change={(value) => { this.$set(this.v_row, itcol.key, value); this.stfgChange() }} size="mini" type="date" clearable={false} value-format="yyyy-MM-dd" style="width:100%"></el-date-picker>
                                            </div>
                                        )
                                    }
                                    if (type === 'number') {
                                        return (
                                            <div>
                                                <div style="margin-top:3px;white-space:nowrap"><el-link underline={false} on-click={() => this.sortHeaderColumn(column, itcol.EDCSS)}>{column.title}</el-link></div>
                                                <el-input type="number" value={this.v_row[itcol.key]} on-input={(event) => { this.$set(this.v_row, itcol.key, event && event.target ? event.target.value : event) }} nativeOn-keyup={(event) => { if (event.keyCode === 13) this.stfgChange() }} placeholder="" size="mini" style="width:100%"></el-input>
                                            </div>
                                        )
                                    }
                                    return (
                                        <div>
                                            <div style="margin-top:3px;white-space:nowrap"><el-link underline={false} on-click={() => this.sortHeaderColumn(column, itcol.EDCSS)}>{column.title}</el-link></div>
                                            <el-input value={this.v_row[itcol.key]} disabled={type === 'image'} on-input={(event) => { this.$set(this.v_row, itcol.key, event && event.target ? event.target.value : event) }} nativeOn-keyup={(event) => { if (event.keyCode === 13) this.stfgChange() }} placeholder="" size="mini" style="width:100%"></el-input>
                                        </div>
                                    )
                                },
                                ellipsis: { showTitle: true },
                                renderBodyCell: ({row}) => {
                                    const rowVal = row[itcol.key]
                                    if (itcol.key === 'IDNO') {
                                        return <el-link underline={false} on-click={() => this.repBtn(row)}><div style="color:#409eff;border-bottom:1px solid red;font-size:12px">{rowVal}</div></el-link>
                                    }
                                    if (itcol.key === 'STFG') {
                                        return rowVal === 'Y'
                                            ? <el-tag size="mini" type="success" effect="dark">{this.$LANG('1976', '已审核')}</el-tag>
                                            : rowVal === 'N'
                                                ? <el-tag size="mini" type="info" effect="dark">{this.$LANG('2005', '未审核')}</el-tag>
                                                : <el-tag size="mini" type="danger" effect="dark"> 审核中 </el-tag>
                                    }
                                    return <span>{rowVal}</span>
                                },
                            })
                        }
                    })
                    vm.vueCol.unshift({
                        field: 'index',
                        key: 'rownum',
                        title: vm.$LANG('0310', '序号'),
                        width: 60,
                        align: 'center',
                        fixed: 'left',
                        disableResizing: true,
                        renderBodyCell: ({rowIndex}) => rowIndex + 1,
                        renderHeaderCell: ({column}) => (
                            <div>
                                <div style="margin-top:3px;white-space:nowrap">{column.title}</div>
                                <el-link on-click={vm.rowShow} style="font-size:12px;color:#404eff">
                                    <el-tooltip content={vm.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip>
                                </el-link>
                            </div>
                        ),
                    })
                    vm.vueCol.push({
                        field: 'oper0',
                        key: 'oper',
                        title: vm.$LANG('0330', '状态操作'),
                        width: 200,
                        align: 'center',
                        fixed: 'right',
                        disableResizing: true,
                        renderBodyCell: ({row, rowIndex}) => (
                            <div>
                                <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px"></i>
                                <el-link on-click={() => this.editRec(row, 'Y', rowIndex)} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0139', '查看')}</span></el-link>
                                {row.STFG === 'N' ? <span>
                                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px"></i>
                                    <el-link on-click={() => this.editRec(row, 'N', rowIndex)} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('1639', '编辑')}</span></el-link>
                                    <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px"></i>
                                    <el-link on-click={() => this.stfgRec(row, 'K', rowIndex)} underline={false}><span style="font-size:12px;margin-right:5px">确认</span></el-link>
                                    <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px"></i>
                                    <el-link on-click={() => this.stfgRec(row, 'X', rowIndex)} underline={false}><span style="font-size:12px">{this.$LANG('0257', '作废')}</span></el-link>
                                </span> : null}
                                {row.STFG === 'Y' ? <span>
                                    <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px"></i>
                                    <el-link on-click={() => this.stfgRec(row, 'N', rowIndex)} underline={false}><span style="font-size:12px;margin-right:5px"> 弃审 </span></el-link>
                                </span> : null}
                                {row.STFG === 'K' ? <span>
                                    <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px"></i>
                                    <el-link on-click={() => this.stfgRec(row, 'N', rowIndex)} underline={false}><span style="font-size:12px;margin-right:5px"> 弃认 </span></el-link>
                                </span> : null}
                            </div>
                        ),
                    })
                    vm.applyFieldSettingRows()
                    return res
                })
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','96','lstseq','2','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        notnull:res.result[k].NOTNULL,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
 
        },
    }
}
</script>
<style scoped lang="less">
    .item-width  {
        width: 32%;
        color:#409EFF;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px;
            color:rgb(11, 11, 59);
            font-size:12px;
            background:rebeccapurple;
        }
        td {
            padding: 5px ;
            font-size:11px;
        } 
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    //.el-dialog__headerbtn i { background:white;font-size: 20px;  }
    .el-table .success-row {
        color:#959997;
    }
    .el-table .cancel-row {
        color: #e00e66;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
